import React from "react";
import {OrbitSwiperComponent} from "../../../../../components/orbit-swiper/orbit-swiper.component";
import {SwiperListBaseModel} from "../swiper-list-base.model";

export class StaticSwiperListModel extends SwiperListBaseModel  {

    protected _shouldBeDisplayed(): boolean {
        return super._shouldBeDisplayed() && this.gameTypes.length > 0;
    }

    _renderList(listPosition: number): React.ReactElement | null {
        const listConfig = this.listConfiguration;


        return (
            <OrbitSwiperComponent
                viewModel={this}
                key={this.listKey}
                listPosition={listPosition}
                showNumberBadge={listConfig.showNumberBadge}
            />
        );
    }
}